import Modal from "aldoo-ra/Modal"
import MediaLibraryContent from "./media-library-content"

export default function MediaLibrary({
  isOpen = false,
  onClose,
  onFileSelect,
  title = "Media Library",
  allowMultiSelect = false,
  defaultFileType = null,
  zIndex,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      variant="admin"
      className="md:absolute w-full md:w-[85%] h-full md:h-[85vh]"
      closeOnEscape
      zIndex={zIndex}
      styleOverrides={{
        header: "pt-0",
        closeButton:
          "absolute top-4 right-4 z-10 h-10 w-10 flex items-center justify-center bg-admin_paper rounded-full hover:bg-admin_neutral_1",
        closeIcon: "h-6 w-6 text-admin_text_secondary",
        contentWrapper: "pt-0 flex flex-col flex-1 overflow-hidden",
        content: "p-0 flex flex-col flex-1 overflow-hidden",
        container:
          "w-full md:w-[85%] h-full md:h-[85vh] bg-admin_paper border border-admin_bordered md:rounded-lg overflow-hidden flex flex-col",
      }}
    >
      {isOpen && (
        <MediaLibraryContent
          title={title}
          onFileSelect={onFileSelect}
          onClose={onClose}
          allowMultiSelect={allowMultiSelect}
          defaultFileType={defaultFileType}
          zIndex={zIndex}
        />
      )}
    </Modal>
  )
}
